import { SCREEN_PRESENTER } from '@shoflo/polymer';
import setFeaturedPresenter from '../program/setFeaturedPresenter';
import reorderSources from './reorderSources';

const getNumberOfScreenShares = sources =>
  sources.filter(s => s.type === SCREEN_PRESENTER).length;

export default presenter => {
  return (dispatch, getState) => {
    const {
      broadcastSources: { sources }
    } = getState();
    const { _id: presenterId } = presenter;
    const clickedSource = {
      ...presenter,
      sourceType: presenter.type,
      id: presenter._id
    };
    const numberOfScreenShares = getNumberOfScreenShares(sources);

    dispatch(reorderSources(clickedSource, numberOfScreenShares));
    dispatch(setFeaturedPresenter(presenterId));
  };
};
